var map = {
	"./MANI LPCL.jpg": 1023,
	"./lpcl-1.png": 1478,
	"./lpcl-2.png": 2685,
	"./lpcl-3.png": 1556,
	"./lpcl-4.png": 1467,
	"./lpcl-5.png": 7314,
	"./lpcl-6.png": 3897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5518;